import MainCatalogsEditorBase from '../../MainCatalogsEditorBase';
import { compose, mdsWidget, mdsLazyProto } from 'dojo/_base/declare';
import template from './FunctionalMainGroupEditor.html?raw';
import Edit from '../../../../moreCore/UI/Edit/Edit';
import NumberInput from '../../../../moreCore/UI/NumberInput/NumberInput';
import { MainCatalogTypes, MainCatalogs_Classes } from "../../../_loadingHelpers/MainCatalogTypes";

class FunctionalMainGroupEditor extends compose(MainCatalogsEditorBase) {
    templateString: any = template;


    fmg_Input_Code: MdsLax<InstanceType<typeof Edit>>;
    fmg_Input_Description: MdsLax<InstanceType<typeof Edit>>;
    fmg_Input_TextColor: HTMLInputElement;
    fmg_Input_BackgroundColor: HTMLInputElement;
    fmg_Input_Order: MdsLax<InstanceType<typeof NumberInput>>;

    formData: MainCatalogTypes.FunctionalMainGroup_SaveData = {
        ID: "",
        is_new_status: null,
        code: "",
        description: "",
        order: null,
        coloration: null
    };

    prepareFormData(data?: MainCatalogTypes.FunctionalMainGroup_LoadData): void {

        if (data) {

            this.fmg_Input_Code.setValue(data.code, true);
            this.fmg_Input_Description.setValue(data.description_D, true);

            this.fmg_Input_TextColor.value = data.coloration.TextColor.Hex;
            this.fmg_Input_BackgroundColor.value = data.coloration.BackColor.Hex;

            this.fmg_Input_Order.setValue(data.order, true);

            this.formData.ID = data.ID;
            this.formData.is_new_status = false;
        } else {

            this.fmg_Input_Code.setValue("", true);
            this.fmg_Input_Description.setValue("", true);

            this.fmg_Input_BackgroundColor.value = "#ffffff";
            this.fmg_Input_TextColor.value = "#000000";

            this.fmg_Input_Order.setValue(null, true);

            this.formData.ID = "";
            this.formData.is_new_status = true;
        }

        this.serializeFormData();
        this.originalData = JSON.stringify(this.formData);
        console.debug("ORIGINAL", this.originalData);
        this.StandbyStop();

        this.checkDirty();
    }

    serializeFormData(): void {

        this.formData.code = this.fmg_Input_Code.getValue();
        this.formData.description = this.fmg_Input_Description.getValue();

        this.formData.order = this.fmg_Input_Order.getValue();

        let coloration: MainCatalogTypes.PIT_Coloration = {
            TextColor: null,
            BackColor: null
        };
        let textColor: MainCatalogTypes.PIT_Color = {
            Hex: "",
            Red: 0,
            Green: 0,
            Blue: 0
        };
        let backColor: MainCatalogTypes.PIT_Color = {
            Hex: "",
            Red: 0,
            Green: 0,
            Blue: 0
        };
        let textHex = this.fmg_Input_TextColor.value;
        let backHex = this.fmg_Input_BackgroundColor.value;

        textColor.Hex = textHex;
        textColor.Red = parseInt(textHex.slice(1, 3), 16);
        textColor.Green = parseInt(textHex.slice(3, 5), 16);
        textColor.Blue = parseInt(textHex.slice(5, 7), 16);

        backColor.Hex = backHex;
        backColor.Red = parseInt(backHex.slice(1, 3), 16);
        backColor.Green = parseInt(backHex.slice(3, 5), 16);
        backColor.Blue = parseInt(backHex.slice(5, 7), 16);

        coloration.TextColor = textColor;
        coloration.BackColor = backColor;

        this.formData.coloration = coloration;

        console.debug("SERIALIZED DATA", this.formData);
    }





    _onChangeFunctionalMainGroupInputData(): void {

        this.serializeFormData();
        this.checkDirty();
    }

    isValid(): boolean {

        let b: boolean = true;

        if (!this.formData.code) b = false;

        if (!this.formData.description) b = false;

        return b;
    }


    //BASE
    postCreate(): void {
        super.postCreate.apply(this, arguments as any);

        this.entityClass = MainCatalogs_Classes.FunctionalMainGroup;

        this.fmg_Input_Code.setMaxLength(10);
        this.fmg_Input_Description.setMaxLength(255);
    }
    startup(): void {
        super.startup.apply(this, arguments as any);
    }
}

mdsLazyProto(FunctionalMainGroupEditor.prototype, {
  fmg_Input_Code: () => (new Edit()),
  fmg_Input_Description: () => (new Edit()),
  fmg_Input_Order: () => (new NumberInput()),
});
export default mdsWidget(FunctionalMainGroupEditor);
